import { render, staticRenderFns } from "./AuditDetail.vue?vue&type=template&id=735c2a22&scoped=true"
import script from "./AuditDetail.vue?vue&type=script&lang=ts"
export * from "./AuditDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c2a22",
  null
  
)

export default component.exports